import { render } from "./FormErrorBox.vue?vue&type=template&id=3bc0b5f0"
import script from "./FormErrorBox.vue?vue&type=script&lang=js"
export * from "./FormErrorBox.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/volume-nbg1-3/html/musikalienverleih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__